import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'
import { ListItemText } from 'material-ui/List'
import Select from 'material-ui/Select'
import Checkbox from 'material-ui/Checkbox'
import Input, { InputLabel } from 'material-ui/Input'
import { MenuItem } from 'material-ui/Menu'
import Switch from 'material-ui/Switch'
import { FormGroup, FormControlLabel, FormLabel } from 'material-ui/Form'
import {
  LineChart,
  ReferenceLine,
  Line,
  Area,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Text,
  Label,
  ReferenceArea
} from 'recharts'
import Button from 'material-ui/Button'
import Icon from 'material-ui/Icon'

import CustomLegend from '../../../components/legend'
import { withStyles } from 'material-ui/styles'
import styles from './styles'

class LineChartViewer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      refAreaLeft: '',
      refAreaRight: '',
      left: 'auto',
      right: 'auto',
      data: props.data
    }
  }

  zoom = () => {
    let { refAreaLeft, refAreaRight, data } = this.state
    if (refAreaLeft === refAreaRight || refAreaRight === '') {
      this.setState({
        refAreaLeft: '',
        refAreaRight: ''
      })
      return
    }

    if (refAreaLeft > refAreaRight) {
      ;[refAreaLeft, refAreaRight] = [refAreaRight, refAreaLeft]
    }

    this.setState(() => ({
      refAreaLeft: '',
      refAreaRight: '',
      data: data.slice(),
      left: refAreaLeft,
      right: refAreaRight
    }))
  }

  zoomOut = () => {
    let { data } = this.state
    this.setState(() => ({
      refAreaLeft: '',
      refAreaRight: '',
      data: data.slice(),
      left: 'auto',
      right: 'auto'
    }))
  }

  setFullView = e => {
    const { graphType, renderFullView } = this.props
    renderFullView(graphType)
  }
  formatXAxis = tickItem => {
    return Math.round(tickItem)
  }

  render() {
    const {
      classes,
      translate,
      pairs,
      type,
      height,
      selectedPairs,
      combinedSelectedPairs,
      chartLineStyle,
      chartMeasurement,
      showMargin,
      fullView,
      combined,
      subtest,
      CustomTooltip
    } = this.props;

    const { left, right, refAreaLeft, refAreaRight, data } = this.state
    let tickcount = null
    if (data.length !== 0) {
      tickcount = ((Math.round(data[data.length - 1].name / 50) + 1) > 5) ? (Math.round(data[data.length - 1].name / 50) + 1) : (Math.round(data[data.length - 1].name) < 5) ? (Math.round(data[data.length - 1].name)) : 5
    }

    return (
      <div
        ref='line-chart-container'
        align='center'
        className={classes.chartContainer}
      >
        <Grid container spacing={24}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography type={'title'}>{type}</Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            md={12}
            xl={12}
            align='right'
          >
            {left !== 'auto' &&
              right !== 'auto' &&
              <Button mini onClick={this.zoomOut}>
                <Icon>{'zoom_out'}</Icon>
              </Button>}
            <Button mini onClick={this.setFullView}>
              <Icon>{fullView ? 'fullscreen_exit' : 'fullscreen'}</Icon>
            </Button>
          </Grid>
        </Grid>

        <ResponsiveContainer width='100%' height={height}>
          <LineChart
            data={data}
            label='data'
            onMouseDown={e => {
              if (e) this.setState({ refAreaLeft: e.activeLabel })
            }}
            onMouseMove={e => {
              this.state.refAreaLeft &&
                this.setState({ refAreaRight: e.activeLabel })
            }}
            onMouseUp={this.zoom}
          >
            <XAxis
              dataKey='name'
              minTickGap={30}
              padding={{ left: 20, right: 20 }}
              scale={chartMeasurement}
              allowDecimals={false}
              type='number'
              // interval={0}
              tickCount={tickcount}
              // ticks={[50, 100, 150, 200, 250, 300, 350, 400, 450, 500]}
              domain={[left, right]}
              allowDataOverflow
              tick={{ fontSize: '12px' }}
            >
              <Label
                value={translate('Frequency (MHz)')}
                offset={-5}
                position='insideBottom'
                fontSize='14px'
              />
            </XAxis>

            <YAxis
              reversed={chartLineStyle === 'inverted'}
              interval='preserveStartEnd'
              label={{
                value: `${translate(subtest)}  (${translate('dB')})`,
                offset: 15,
                angle: -90,
                dy: 20,
                position: 'insideLeft',
                fontSize: '14px'
              }}
              tick={{ fontSize: '12px' }}
            />
            <CartesianGrid strokeDasharray='3 3' />
            <Tooltip
              translate={translate}
              content={CustomTooltip}
              pairs={pairs}
              selectedPairs={selectedPairs}
              showMarginValue={showMargin}
              combinedSelectedPairs={combinedSelectedPairs}
              combined={combined}
              subtest={subtest}
            />
            <Text scaleToFit />
            {selectedPairs &&
              selectedPairs.map((pair, key) => {
                let k = key;
                if (pair.value === 'Limit') {
                  //k = 'limit';
                }
                return (
                  <Line
                    key={key}
                    hide={!pair.checked}
                    type='monotone'
                    dataKey={k}
                    stroke={pair.stroke}
                    dot={false}
                  />
                )
              })}
            (combined) &&
            {combinedSelectedPairs &&
              combinedSelectedPairs.map((pair, key) => {
                return (
                  <Line
                    key={key + pair.tempKey}
                    hide={!pair.checked}
                    type='monotone'
                    dataKey={key + pair.tempKey}
                    stroke={pair.stroke}
                    dot={false}
                  />
                )
              })}
            <Legend
              content={<CustomLegend translate={translate} />}
              selectedPairs={selectedPairs}
              pairs={pairs}
              align='left'
              verticalAlign='bottom'
              wrapperStyle={{ top: height + 5 }}
            />
            {refAreaLeft && refAreaRight
              ? <ReferenceArea
                x1={refAreaLeft}
                x2={refAreaRight}
                strokeOpacity={0.3}
              />
              : null}
          </LineChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

export default withStyles(styles)(LineChartViewer)
